import styled from '@emotion/styled';

export const AuthLayoutStyled = styled.div`
  background: linear-gradient(145deg, #c8eeeb 20%, #b789ff 70%);
`;
